import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Checkbox, Col, DatePicker, Divider, Flex, Input, Modal, Row, Select, Space} from 'antd';
import {URL_ADMIN, URL_HQ, URL_HQ_STORE_COUNSEL_ADD, URL_HQ_STORE_COUNSEL_DETAIL} from 'routes/AdminRoute';
import {BaseSection, TitleLayout} from 'components/layouts';
import {AlertModal, BaseContainer, ConfirmModal, SearchDesc} from 'components/containers';
import {AreaSearch, BaseButton, DataGrid, FillButton, OutlinedButton, ExcelButton, BaseDatePicker} from 'components/elements';
import {Attachment, GridSetting, UploadFile} from 'pages/common';
import {fnSetColumn, getFormatDate, utilSearchData} from 'utils/utils';
import {
  storeCognitivePathOptions,
  searchTypeOptions,
  storeCounsel1stResultOptions,
  storeCounselResultOptions,
  storeSuccessRateOptions
} from 'data/options';
import {getListAPI, postColUpdateAPI} from 'api/common';
import {deleteStoreCounselAPI, postDeleteStoreCounselAPI} from 'api/store-counsel';
import dayjs from 'dayjs';
import {exportStyleExcelDownload} from 'utils/file';
import {getLocalStorage} from 'hooks/useLocalStorage';
import {IconDownloadExcel} from 'components/assets/icons';

const StoreCounsel = () => {
  const navigate = useNavigate();
  const menu = getLocalStorage('openMenuInfo');
  const [excelHeaders, setExcelHeaders] = useState([])
  const [colList, setColList] = useState({
    gridSettingList: [],
    gridList: []
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [rowChecked, setRowChecked] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [columnList, setColumnList] = useState([]);
  const [staticsList, setStaticsList] = useState([]);
  const [uploadResume, setUploadResume] = useState({
    resume: '',
    resume_path: ''
  });
  const [searchData, setSearchData] = useState({
    inquiry_start_date: '',
    inquiry_end_date: '',
    counsel_1st_status: '-1',
    counsel_2st_status: -1,
    sido: '',
    sigungu_cd: '',
    success_rate: '-1',
    search_state: 'proposer_name',
    search_content: '',
    cognitive_path: []
  });
  const [alertModal, setAlertModal] = useState({
    open: false,
    message: ''
  });
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    message: ''
  });
  const [modal, setModal] = useState({
    open: false,
    idx: ''
  });
  const [row, setRow] = useState();

  const fnCloseAlertModal = () => {
    setAlertModal({...alertModal, open: false, message: ''});
  };

  const fnCloseConfirmModal = () => {
    setConfirmModal({
      ...confirmModal,
      open: false,
      message: ''
    });
  };

  const fnDeleteConfirmModal = () => {
    if (rowChecked?.length === 0) {
      setAlertModal({
        ...alertModal,
        open: true,
        message: '선택된 가맹상담이 없습니다.'
      });
      return;
    }

    setConfirmModal({...confirmModal, open: true, message: '정말로 삭제하시겠습니까?'});
  };

  const fnSetArea = (v, key) => {
    setSearchData({...searchData, [key]: v});
  };


  
  const fnUploadResume = async (idx) => {
    try {
      const sendData = {};
      if (!uploadResume?.resume) {
        setAlertModal({...alertModal, open: true, message: '이력서를 선택해주세요.'});
        return;
      }

      sendData.idx = idx;
      sendData.table_name = 'TB_STORE_COUNSEL';
      sendData.colum_name = 'RESUME_PATH';
      sendData.update_colum_data = uploadResume?.resume_path;

      const {data} = await postColUpdateAPI(sendData);
      if (data?.responseCode === 200) {
        setModal({...modal, open: false, idx: ''});
        setAlertModal({...alertModal, open: true, message: '업로드 되었습니다.'});
        fnGetList();
      }
    } catch (error) {
      setAlertModal({...alertModal, open: true, message: '업로드 도중 문제가 발생하였습니다.'});
      console.error(error);
    }
  };

  const fnDeleteRow = async () => {
    try {
      const sendData = rowChecked;
      let result = {};
      if (sendData?.length === 1) {
        result = await deleteStoreCounselAPI(sendData?.[0]);
      }

      if (sendData?.length > 1) {
        result = await postDeleteStoreCounselAPI(sendData);
      }

      if (result?.data?.responseCode === 200) {
        setAlertModal({...alertModal, open: true, message: '삭제 되었습니다.'});
        fnCloseConfirmModal();
        fnGetList();
      }
    } catch (error) {
      setAlertModal({
        ...alertModal,
        open: true,
        message: '삭제도중 서버통신 오류가 발생했습니다.'
      });
      console.error(error);
    }
  };

  const onRow = (record, rowIndex) => {
    return {
      onClick: (event) => {
      }, // click row
      onDoubleClick: (event) => {
      }, // double click row
      onContextMenu: (event) => {
      }, // right button click row
      onMouseEnter: (event) => {
      }, // mouse enter row
      onMouseLeave: (event) => {
      } // mouse leave row
    };
  };

  const fnGetList = async () => {
    try {
      // 공통 서치바 데이터 체크 및 데이터 리턴
      const result = utilSearchData({...searchData, sigungu_cd: searchData?.sigungu_cd?.substr(0, 5)});

      if (typeof result === 'string') {
        setAlertModal({...alertModal, open: true, message: result});
      } else {
        const {data} = await getListAPI(result);
        setExcelHeaders(fnSetColumn(data.COLUMS_LIST, columns))
        setColList({
          ...colList,
          gridSettingList: data?.COLUMS_LIST,
          gridList: fnSetColumn(data?.COLUMS_LIST, columns)
        });
        setColumnList(data?.COLUMS_LIST);
        setDataList(data?.DATA_LIST);
        setStaticsList(data?.STATICS_LIST);
      }
    } catch (error) {
      setAlertModal({
        ...alertModal,
        open: true,
        message: '리스트 호출도중 오류가 발생했습니다.'
      });
      console.error(error);
    }
  };

  useEffect(() => {
    fnGetList();
  }, []);


  const items = [
    {
      key: 1,
      label: '문의일',
      children: 
        <Space>
          <BaseDatePicker
            value={searchData?.inquiry_start_date}
            onChange={dateString => setSearchData({ ...searchData, inquiry_start_date: dateString })}
          />
          ~
          <BaseDatePicker
            value={searchData?.inquiry_end_date}
            onChange={dateString => setSearchData({ ...searchData, inquiry_end_date: dateString})}
          />
        </Space>,
      span: 1
    },
    {
      key: 2,
      label: '상담상태',
      children: 
        <Space>
          <Select placeholder={'1차 결과'} value={searchData?.counsel_1st_status} style={{width: '12rem'}}
                  options={storeCounsel1stResultOptions}
                  onSelect={(v) => setSearchData({...searchData, counsel_1st_status: v})}/>
          <Select placeholder={'최종 결과'} style={{width: '12rem'}} options={storeCounselResultOptions}
                  value={searchData?.counsel_2st_status}
                  onSelect={(v) => setSearchData({...searchData, counsel_2st_status: v})}/>
        </Space>,
      span: 1
    },
    {
      key: 3,
      label: '개설희망지역',
      children: <AreaSearch onSelect={fnSetArea}/>,
      span: 1
    },
    {
      key: 4,
      label: '가맹성공율',
      children: (
        <>
          <Select placeholder={'전체'} value={searchData?.success_rate} style={{width: '12rem'}}
                  options={storeSuccessRateOptions} onSelect={(v) => setSearchData({...searchData, success_rate: v})}/>
        </>
      ),
      span: 1
    },
    {
      key: 5, span: 2,
      label: '검색조건',
      children:
        <Space>
          <Select placeholder={'선택'} value={searchData?.search_state} style={{width: '12rem'}}
                  options={searchTypeOptions(['신청자명', '휴대폰번호', '연결지사명', '작성자'])}
                  onSelect={(v) => setSearchData({...searchData, search_state: v})}/>
          <Input style={{width: '20rem'}} value={searchData?.search_content}
                 onChange={(v) => setSearchData({...searchData, search_content: v.target.value})} onPressEnter={fnGetList}/>
        </Space>
    },
    {
      key: 6,
      label: '인지경로',
      children: (
        <Checkbox.Group
          options={storeCognitivePathOptions}
          value={searchData?.cognitive_path}
          onChange={(v) => {
            setSearchData({...searchData, cognitive_path: v});
          }}
        />
      ),
      span: 2
    }
  ];

  const columns = [
    {
      title: '상담번호',
      align: 'center',
      dataIndex: 'IDX'
    },
    {
      title: '문의일',
      align: 'center',
      dataIndex: 'INQUIRY_DATE',
      render: (item) => {
        return getFormatDate(item);
      }
    },
    {
      title: '신청자명',
      align: 'center',
      dataIndex: 'PROPOSER_NAME'
    },
    {
      title: '나이',
      align: 'center',
      dataIndex: 'AGE'
    },
    {
      title: '휴대폰번호',
      align: 'center',
      dataIndex: 'CELL_PHONE'
    },
    {
      title: '개설희망지역',
      align: 'center',
      dataIndex: 'HOPE_AREA',
      width: '300px'
    },
    {
      title: '인지경로',
      align: 'center',
      dataIndex: 'COGNITIVE_PATH',
      render: (item, row) => {
        const c_path = item?.split(',');
        return c_path?.map(it => storeCognitivePathOptions?.find(i => i.value === it)?.label)?.join(',');
      }
    },
    {
      title: '1차',
      align: 'center',
      dataIndex: 'RESULT_FIRST',
      render: (item) => storeCounsel1stResultOptions?.find(it => it.value === item)?.label
    },
    {
      title: '최종결과',
      align: 'center',
      dataIndex: 'RESULT_LAST',
      render: (item) => storeCounselResultOptions?.find((it) => it.value == item)?.label
    },
    {
      title: '가맹성공율',
      align: 'center',
      dataIndex: 'SUCCESS_RATE',
      render: (text) => {
        return text === '1' ? '상' : text === '2' ? '중' : text === '3' ? '하' : ''
      }
    },
    {
      title: '상세보기',
      align: 'center',
      render: (item, row) => {
        return (
          <OutlinedButton
            label="상세"
            onClick={(event) => {
              navigate(`${URL_ADMIN + URL_HQ}${URL_HQ_STORE_COUNSEL_DETAIL.replace(':no', row.IDX)}`);
            }}
          />
        );
      }
    },
    {
      title: '이력서',
      align: 'center',
      whidth: '100px',
      render: (item, row) => {
        if (item?.RESUME_PATH) return <Attachment icon={'download'} label={row?.RESUME} url={row?.RESUME_PATH}/>
      }
    },
    {
      title: '작성자',
      align: 'center',
      dataIndex: 'WRITER'
    },
    {
      title: '연결지사명',
      align: 'center',
      dataIndex: 'LINKED_BRANCH'
    }
  ];

  const rowSelection = {
    type: 'checkbox',
    selectedRowKeys: rowChecked,
    onChange: (selectedRowKeys, selectedRows) => {
      setRowChecked(selectedRowKeys);
    }
  };

  return (
    <>
      <BaseSection>
        <Flex gap={'7px'}>
          <Col flex="auto">
            <SearchDesc stats={staticsList} items={items} column={2} onSearch={fnGetList}/>
          </Col>
        </Flex>
        <BaseContainer>
          <Row>
            <Col span={20}>
              <Space>
                <GridSetting colList={columnList} fnUpdateCol={fnGetList}/>
                <ExcelButton
                  // label={'엑셀 다운로드(검색)'} //뷰네임 미입력시 기본값
                  // isCheckComp={true} //체크박스 컴포넌트 여부 미입력시 X
                  headerList={excelHeaders} //필수 헤더리스트 표 설정과 동일한 변수여야함
                  gridList={dataList} //필수 실시간 그리드 데이터
                  // filterList={[]} //뺄 칼럼 목록 dataIndex 미입력시 dataIndex 키 없는것만 뺌
                  // renderList={[]} //코드 or 다른이름으로 바꿔서 다운할 목록
                  // checkRows={} //isCheckComp true 일시 checkRows 데이터 미입력시 체크작동안함
                  // checkKey={} //isCheckComp true 일시 check 한 데이터 dataIndex 키 네임 미입력시 체크작동안함
                  // fileName={} //파일네임 미입력시 해당 메뉴이름
                />
              </Space>
            </Col>
            <Col span={4}>
              <Flex justify="flex-end" gap="small">
                <OutlinedButton label="삭제" color={'var(--color-red04'} onClick={fnDeleteConfirmModal}/>
                <FillButton
                  label="등록"
                  backgroundColor="var(--color-gray03)"
                  onClick={(event) => {
                    navigate(`${URL_ADMIN + URL_HQ}${URL_HQ_STORE_COUNSEL_ADD}`);
                  }}
                />
              </Flex>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Divider className="divider-small"/>

              <DataGrid
                rowKey={'IDX'}
                columns={excelHeaders}
                data={dataList}
                pagination
                rowSelection={{
                  type: 'checkbox',
                  ...rowSelection
                }}
                currentPage={currentPage}
                onChange={(value) => setCurrentPage(value)}
                onRow={onRow}
              />
            </Col>
          </Row>
        </BaseContainer>
        <Modal
          centered
          width={'40%'}
          onCancel={() => setModal({...modal, open: false, idx: ''})}
          open={modal?.open}
          style={{
            footer: {textAlign: 'center'}
          }}
          footer={[<FillButton rowKey={'upload'} label="파일업로드" backgroundColor={'var(--color-blue01)'}
                               onClick={() => fnUploadResume(modal?.idx)}/>,
            <OutlinedButton rowKey={'uploadCancel'} label="취소하기" color={'var(--color-gray03)'}
                            onClick={() => setModal({...modal, open: false, idx: ''})}/>]}
        >
          <BaseContainer>
            <Row>
              <Col span={24}>
                <TitleLayout>이력서 첨부파일 등록</TitleLayout>
              </Col>
            </Row>
            <Divider className="divider">
              <hr/>
            </Divider>
            <Row>
              <Col>
                <UploadFile data={uploadResume?.resume} onChange={(v) => setUploadResume({
                  ...uploadResume,
                  resume: v?.origin_file_name,
                  resume_path: v?.file_path
                })} onDelete={() => setUploadResume({...uploadResume, resume: '', resume_path: ''})}/>
              </Col>
            </Row>
          </BaseContainer>
        </Modal>
        {/* 삭제 confirm 모달 */}
        <ConfirmModal open={confirmModal?.open} onCancel={fnCloseConfirmModal} onConfirm={fnDeleteRow}>
          {confirmModal?.message}
        </ConfirmModal>
        {/* alert 모달 */}
        <AlertModal open={alertModal?.open} onCancel={fnCloseAlertModal}>
          {alertModal?.message}
        </AlertModal>
      </BaseSection>
    </>
  );
};

export default StoreCounsel;
